import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { addScrollClickTrigger, init as initHashScrolling } from '@project/shared/utils/hashscrolling/js/hashscrolling';

const classes: any = {
	headerTop: 'js-o-header-campaign__top',
	wrapper: 'js-o-header-campaign__wrapper',
	ctaArea: 'js-o-header-campaign__cta-area',
	button: 'js-o-header-campaign__button',
	stateFixed: 'state-o-header-campaign--fixed',
	stateNearTop: 'state-o-header-campaign--near-top',
	stateLogoTouchedHeadline: 'state-o-header-campaign--logo-touched-headline',
};

@createModule('HeaderCampaign')
/**
 * Header module implementation.
 *
 * @author Christoph Merkelbach <christoph.merkelbach@namics.com>
 */
export class HeaderCampaign extends TerrificSpec {
	ticking: boolean = false;
	$ctx: JQuery;
	$headerTop: JQuery;
	$wrapper: JQuery;
	$ctaArea: JQuery;
	pageStartToLogoEndHeight: number;
	lineHeightLargeHeadline: number;
	logoHeightPlusMarginTop: number;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$headerTop = this.$ctx.find(`.${classes.headerTop}`);
		this.$wrapper = this.$ctx.find(`.${classes.wrapper}`);
		this.$ctaArea = this.$ctx.find(`.${classes.ctaArea}`);
		this.pageStartToLogoEndHeight = 118;
		this.lineHeightLargeHeadline = 48;
		this.logoHeightPlusMarginTop = 77;

		window.addEventListener('scroll', this.requestScrollTick.bind(this), false);
		window.addEventListener('resize', this.onResize.bind(this), false);

		this.handleCtaButtonClick();
		this.requestScrollTick();

		resolve();
	}

	scrollUpdate() {
		const scrollTop = $(window).scrollTop();
		this.$ctx.toggleClass(classes.stateFixed, scrollTop > this.$ctaArea.offset().top);
		this.$ctx.toggleClass(classes.stateNearTop, scrollTop > this.$ctaArea.offset().top - 20);

		const logoTouchesHeadlinePosition = this.$wrapper.offset().top - this.pageStartToLogoEndHeight;

		this.$ctx.toggleClass(
			classes.stateLogoTouchedHeadline,
			scrollTop > this.$ctaArea.offset().top - this.logoHeightPlusMarginTop
		);

		if (scrollTop < logoTouchesHeadlinePosition) {
			this.$headerTop.addClass('state-o-header-campaign__top--expand');
			this.$headerTop.removeClass('state-o-header-campaign__top--collapse');
		} else {
			this.$headerTop.addClass('state-o-header-campaign__top--collapse');
			this.$headerTop.removeClass('state-o-header-campaign__top--expand');
		}
		this.ticking = false;
	}

	onResize() {
		this.requestScrollTick();
	}

	/**
	 * Debounces animation with browser's requestAnimation Frame to provide performance and
	 * keep page smoothly scrollable even on older machines
	 */
	requestScrollTick() {
		if (!this.ticking) {
			requestAnimationFrame(this.scrollUpdate.bind(this));
			this.ticking = true;
		}
	}

	private handleCtaButtonClick(): void {
		const button = this.$ctx.find(`.${classes.button}`);
		const url = button.attr('href');
		const idx = url.indexOf('#');

		if (idx === 0) {
			this.applyScrollToHandler(button);
		} else {
			return;
		}
	}

	private applyScrollToHandler(button: JQuery<HTMLElement>): void {
		initHashScrolling();
		addScrollClickTrigger(button);
	}

	stop() {
		// Stop
	}
}
